import React from 'react'
import { NarrativeBlock as NarrativeBlockData } from '@marketing-milk/interfaces'
import { SurfacePalette, type } from '../../../tokens'
import { useSectionNumber } from '../../PacketSectionsContext'
import { NarrativeBuiltInSectionKey } from '../../sections'
import { PresentPage } from '../PresentPage'

interface Props {
  palette: SurfacePalette
  sectionKey: NarrativeBuiltInSectionKey
  label: string
  packetID: number
  narrative: NarrativeBlockData[]
}

export const PresentNarrative = ({ palette, sectionKey, label, packetID, narrative }: Props) => {
  const number = useSectionNumber(sectionKey)
  const text = narrative.find(b => b.sectionKey === sectionKey)?.richText?.trim() ?? ''

  return (
    <PresentPage
      palette={palette}
      number={number}
      title={label}
      commentAnchor={{ type: 'section', id: `${packetID}:${sectionKey}`, label }}
    >
      <div
        style={{
          fontFamily: type.family.serif,
          fontSize: 32,
          lineHeight: 1.4,
          whiteSpace: 'pre-wrap',
          color: text ? palette.text : palette.textFaint,
          fontStyle: text ? 'normal' : 'italic',
          maxWidth: 760,
        }}
      >
        {text || 'Nothing captured for this section.'}
      </div>
    </PresentPage>
  )
}
